import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up deck-folder" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "deck-folder-h" }
const _hoisted_5 = { class: "deck-folder-list" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "deck-folder-name" }
const _hoisted_8 = {
  key: 0,
  class: "deck-folder-owner"
}
const _hoisted_9 = {
  key: 0,
  class: "deck-folder-empty"
}
const _hoisted_10 = { class: "deck-folder-actions" }
const _hoisted_11 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h3", null, _toDisplayString(_ctx.folder ? 'Edit Folder' : 'New Folder'), 1),
      _withDirectives(_createElementVNode("input", {
        id: "deck-folder-name",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
        placeholder: "Folder name",
        maxlength: "100",
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.submit()), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.name]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Decks", -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.selected.length) + " selected", 1)
      ]),
      (_ctx.boards.length > 8)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQ) = $event)),
            placeholder: "Search decks",
            "aria-label": "Search decks"
          }, null, 512)), [
            [_vModelText, _ctx.searchQ]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownBoards, (board) => {
          return (_openBlock(), _createElementBlock("label", {
            key: board.Slug,
            class: _normalizeClass(_ctx.selected.includes(board.Slug) ? 'deck-folder-row on' : 'deck-folder-row')
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: board.Slug,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selected) = $event))
            }, null, 8, _hoisted_6), [
              [_vModelCheckbox, _ctx.selected]
            ]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(board.Name), 1),
            (board.IsTaskManager && board.OwnerName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(board.OwnerName), 1))
              : _createCommentVNode("", true)
          ], 2))
        }), 128)),
        (!_ctx.shownBoards.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.boards.length ? 'No decks match that search.' : 'No decks yet.'), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("input", {
          class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
          type: "submit",
          value: _ctx.folder ? 'Save' : 'Create Folder',
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit()))
        }, null, 10, _hoisted_11),
        (_ctx.folder)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "deck-folder-delete",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.remove()))
            }, "Delete Folder"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}